package com.essntl.features.service.ui.allservice

sealed interface AllServiceNavigation {
    data class AddService(val categoryId: String? = null) : AllServiceNavigation
    data class EditService(val id: String) : AllServiceNavigation
}